export const HISTORICAL_APPLICATIONS_ACTION_TYPES = {
    SET_CURRENT_YEAR: 'HISTORICAL_APPLICATIONS_SET_CURRENT_YEAR',
    SET_HISTORICAL_APPLICATIONS_BASIC_INFO: 'HISTORICAL_APPLICATIONS_SET_HISTORICAL_APPLICATIONS_BASIC_INFO',
    SET_HISTORICAL_APPLICATIONS_INFO: 'HISTORICAL_APPLICATIONS_SET_HISTORICAL_APPLICATIONS_INFO',
    SET_HISTORICAL_ENROLLMENTS_INFO: 'HISTORICAL_APPLICATIONS_SET_HISTORICAL_ENROLLMENTS_INFO',
};

